import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomBreadcrumbComponent } from './breadcrumb.component';
import { RouterModule } from '@angular/router';
import { CmsConfig, I18nModule, PageMetaModule, provideConfig } from '@spartacus/core';

@NgModule({
  imports: [CommonModule, RouterModule, PageMetaModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        BreadcrumbComponent: {
          component: CustomBreadcrumbComponent,
        },
      },
    }),
  ],
  declarations: [CustomBreadcrumbComponent],
  exports: [CustomBreadcrumbComponent],
})
export class CustomBreadcrumbModule {}
